import { RoutingResponse } from './RoutingResponse';
import { Point } from './generalTypes';
import { zipWithNext } from './utils';

export async function route(from: Point, to: Point): Promise<RoutingResponse> {
  const url = `https://osrm.prod.aws.porterbuddy.com/route/v1/driving/${from.lon},${from.lat};${to.lon},${to.lat}`;
  return fetch(url).then(res => res.json() as Promise<RoutingResponse>);
}

export function routeBetweenPoints(points: Point[]) {
  return Promise.all(zipWithNext(points).map(([from, to]) => route(from, to)));
}
